import { SectionDB } from '../db';

// Section

class Section {
  API;

  constructor(API) {
    this.API = API;
  }

  get(id) {
    if (id) {
      return this.API.get(id);
    }
    return this.API.getAll();
  }

  create(data) {
    const newData = { id: Date.now(), ...data };
    return this.API.add(newData);
  }

  put(data) {
    return this.API.set(data);
  }

  delete(id) {
    return this.API.delete(id);
  }
}
const sectionAPI = new Section(SectionDB);
export default sectionAPI;
